var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84 11.59C10.92 11.59 12.61 9.89998 12.61 7.81998C12.61 5.73998 10.92 4.04999 8.84 4.04999C6.76 4.04999 5.07001 5.73998 5.07001 7.81998C5.07001 9.89998 6.76 11.59 8.84 11.59Z",
    fill: "#959FA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.16 17.48V19.2C16.16 19.61 15.83 19.95 15.41 19.95H2.75C2.34 19.95 2 19.61 2 19.2V17.48C2 15.07 3.96 13.11 6.37 13.11H11.79C12.28 13.11 12.75 13.19 13.19 13.35C13.19 13.35 13.19 13.34 13.2 13.35C14.92 13.93 16.16 15.56 16.16 17.48Z",
    fill: "#959FA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.16 17.48V19.2C16.16 19.61 15.83 19.95 15.41 19.95H2.75C2.34 19.95 2 19.61 2 19.2V17.48C2 15.07 3.96 13.11 6.37 13.11H11.79C12.28 13.11 12.75 13.19 13.19 13.35C13.19 13.35 13.19 13.34 13.2 13.35C14.92 13.93 16.16 15.56 16.16 17.48Z",
    fill: "#959FA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.62V18.03C22 18.36 21.73 18.63 21.4 18.63H17.66V17.48C17.66 16.47 17.4 15.51 16.95 14.68C16.76 14.34 16.55 14.02 16.31 13.73C16.14 13.54 15.97 13.35 15.79 13.19H18.57C18.68 13.19 18.78 13.19 18.88 13.21C19.01 13.22 19.14 13.24 19.27 13.27C20.03 13.43 20.69 13.85 21.18 14.41C21.26 14.5 21.34 14.6 21.41 14.71C21.42 14.71 21.42 14.71 21.41 14.72C21.6 15 21.75 15.3 21.85 15.63C21.88 15.74 21.91 15.85 21.93 15.96C21.98 16.17 22 16.39 22 16.62Z",
    fill: "#959FA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.38 11.45C18.0314 11.45 19.37 10.1113 19.37 8.45997C19.37 6.80864 18.0314 5.46997 16.38 5.46997C14.7287 5.46997 13.39 6.80864 13.39 8.45997C13.39 10.1113 14.7287 11.45 16.38 11.45Z",
    fill: "#959FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.f460c972c9470f47c1c0286d2af6dd90.svg";
export { ForwardRef as ReactComponent };